import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const ListaAgno = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="agno" id="miLista" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>2021</option>
        <option>2022</option>
        <option>2023</option>
        <option>2024</option>
        <option>2025</option>
        <option>2026</option>
        <option>2027</option>
        <option>2028</option>
        <option>2029</option>
        <option>2030</option>
        <option>2031</option>
        <option>2032</option>
        <option>2033</option>
        <option>2034</option>
        <option>2035</option>
        <option>2036</option>
        <option>2037</option>
        <option>2038</option>  
        <option>2039</option>
        <option>2040</option>      
      </select>
    </div>
  )
};
const ListaMes = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="mes" id="miLista1" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>Enero</option>
        <option>Febrero</option>
        <option>Marzo</option>
        <option>Abril</option>
        <option>Mayo</option>
        <option>Junio</option>
        <option>Julio</option>
        <option>Agosto</option>
        <option>Septiembre</option>
        <option>Octubre</option>
        <option>Noviembre</option>
        <option>Diciembre</option>
      </select>
    </div>
  )
};
const ListaGrupo = ({handleLista}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="megrupos" id="miLista3" onChange={handleLista}>
        <option>Seleccionar...</option>
        <option>Grupo 1</option>
        <option>Grupo 2</option>
        <option>Grupo 3</option>
        <option>Grupo 4</option>
        <option>Grupo 5</option>
        <option>Redes</option>
        <option>Administrativo</option>
        <option>Externos</option>
        <option>Sin grupo</option>
      </select>
    </div>
  )
};

const DetalleNivel2 = props => {
  return (
    <option dato1={props.elemento.cedula} dato2={props.elemento.ciudad} dato3={props.elemento.email} dato4={props.elemento.telefono} value={props.elemento.nombreUsuario}>{props.elemento.nombreUsuario}</option>
  )
};
const ListaOpe = ({handleLista, list}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel2 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="nombreUsuario" id="miLista2" onChange={handleLista}>
        <option value="">Seleccionar...</option>
        {Nivel2Detalle}
      </select>
    </div>
  )
};


const AddMeta2 = ({styles, list, metaTipo, handleLista1, handleLista2, handleLista3, handleLista4, handleSubmit, handleChange, args, errors}) => {
  return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Meta nueva
      </button>
      <div style={styles.box}>
        <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={styles.label}>Tipo de meta</label>
                  <Form.Input autoComplete="off" name="tipoMeta" id="tipoMeta" value={metaTipo} icon={!errors.length?null: _find(errors, {path:'tipoMeta'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Año</label>
                  <ListaAgno styles={styles} handleLista={handleLista1} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Mes</label>
                  <ListaMes styles={styles} handleLista={handleLista2} />
                </Form.Field>
                {metaTipo!=='Utilidad' &&
                  <Form.Field>
                    <label style={styles.label}>Responsable</label>
                    <ListaOpe list={list} handleLista={handleLista3} />
                  </Form.Field>
                }
                <Form.Field>
                  <label style={styles.label}>Grupo</label>
                  <ListaGrupo styles={styles} handleLista={handleLista4} />
                </Form.Field>
                {metaTipo==='Comercial' &&
                  <Form.Field>
                      <label style={styles.label}>Base para comisión</label>
                      <input type='number' step="1" min="0" autoComplete="off" name="valor" id="valor" placeholder='Valor' onChange={handleChange}/>
                  </Form.Field>
                }
                <Form.Field>
                    <label style={styles.label}>Meta mes</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="meta" id="meta" placeholder='Meta' onChange={handleChange}/>
                </Form.Field>
                <Form.Field>
                    <label style={styles.label}>Meta año total</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="metaAgno" id="metaAgno" placeholder='Meta año' onChange={handleChange}/>
                </Form.Field>
                <Form.Field>
                    <label style={styles.label}>Meta año acumulada</label>
                    <input type='number' step="1" min="0" autoComplete="off" name="metaAcumAgno" id="metaAcumAgno" placeholder='Meta año acum.' onChange={handleChange}/>
                </Form.Field>

                <Button style={styles.confirmar} type='submit' fluid>
                  AGREGAR
                </Button>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default AddMeta2
